var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-progress',{attrs:{"percentage":_vm.progress,"format":_vm.format}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }